import React from "react";


export default function(){
    return(
        <div>
        <div class="pt-6 pb-6">
        <div class="container-fluid appoinment py-5 wow fadeIn" data-wow-delay="0.1s">
            <div class="container pt-5">
                <div class="row gy-5 gx-0">
                    <div class="col-lg-6 pe-lg-5 wow fadeIn" data-wow-delay="0.3s">
                        <h1 class="display-6 text-uppercase text-white mb-4">We’re Always Ready to Discuss Your Legal Case
                        </h1>
                        <p class="text-white mb-5 wow fadeIn" data-wow-delay="0.4s">We offer easy and flexible legal appointments designed to fit your busy schedule, ensuring you get the support you need on time.</p>
                        <div class="d-flex align-items-start wow fadeIn" data-wow-delay="0.5s">
                            <div class="btn-lg-square bg-white">
                                <i class="bi bi-envelope-at text-dark fs-3"></i>
                            </div>
                            <div class="ms-3">
                                <h6 class="text-white text-uppercase">Mail Us</h6>
                                <span class="text-white">Info@smnlegalservices.com</span>
                            </div>
                        </div>
                        <hr class="bg-body" />
                        <div class="d-flex align-items-start wow fadeIn" data-wow-delay="0.6s">
                            <div class="btn-lg-square bg-white">
                                <i class="bi bi-telephone text-dark fs-3"></i>
                            </div>
                            <div class="ms-3">
                                <h6 class="text-white text-uppercase">Call Us</h6>
                                <span class="text-white">042-35464418</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-n5 wow fadeIn" data-wow-delay="0.7s">
                        <div class="bg-white p-5">
                            <h2 class="text-uppercase mb-4">Contact Us</h2>
                            <div class="row g-3">
                                <div class="col-sm-6">
                                    <div class="form-floating">
                                        <input type="text" class="form-control border-0 bg-light" id="name" placeholder="Your Name" />
                                        <label for="name">Your Name</label>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-floating">
                                        <input type="email" class="form-control border-0 bg-light" id="mail" placeholder="Your Email" />
                                        <label for="mail">Your Email</label>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-floating">
                                        <input type="text" class="form-control border-0 bg-light" id="mobile" placeholder="Your Mobile" />
                                        <label for="mobile">Your Mobile</label>
                                    </div>
                                </div>
                            <div className="col-sm-6">
                                <div className="form-floating">
                                    <select className="form-select border-0 bg-light" id="service">
                                        <option selected>Case Type</option>
                                        <option value="">Tax Matters</option>
                                        <option value="">Financial Services</option>
                                        <option value="">Corporate Services</option>
                                        <option value="">Intellectual Property Services</option>
                                        <option value="">Banking and Finance</option>
                                        <option value="">Commercial</option>
                                        <option value="">Water & Power</option>
                                        <option value="">Real Estate Development and Construction</option>
                                        <option value="">Dispute Resolution</option>

                                    </select>
                                    <label for="service">Choose A Service</label>
                                </div>
                            </div>
                                <div class="col-12">
                                    <div class="form-floating">
                                        <textarea class="form-control border-0 bg-light" placeholder="Leave a message here" id="message"
                                            style={{height: "130px"}}></textarea>
                                        <label for="message">Message</label>
                                    </div>
                                </div>
                                <div class="col-12 text-center">
                                    <button class="btn btn-primary w-100 py-3" type="submit">Submit Now</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid px-0 wow fadeInUp" data-wow-delay="0.5s">
            <iframe class="w-100 h-100"
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3400.1863057751198!2d74.3226905756126!3d31.546501274202022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e0!3m2!1sen!2s!4v1753650950799!5m2!1sen!2s"
            frameborder="0" style={{minHeight: "500px", border:"0"}} allowfullscreen="" aria-hidden="false"
            tabindex="0"></iframe>
        </div>
    </div>
        </div>
    )
}